import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FieldsSetting } from "../../../actions";
import { FIELDS } from "../../../constants";
import { resetCurrentSelectedObject } from "../../../actions/FieldsSetting/fieldsSettingActions";

const { DATA_STUDIO_VIEW } = FIELDS;

const {
  startSyncingDataSource,
  updateDataSourceSelected,
  updateDataStdioView,
} = FieldsSetting;

const MapperHeader = ({
  updateDatasource,
  dataSourceSelected,
  syncedData,
  updateStudioView,
  resetCurrObject,
}) => {
  const _selectAnotherDataSource = () => {
    if (syncedData && syncedData.dataSource) {
      updateStudioView(DATA_STUDIO_VIEW.MAPPED_VIEW);
    } else {
      updateDatasource("");
      resetCurrObject();
    }
  };

  const dataSource = FIELDS.DATA_SOURCES.find(
    source => source.name === dataSourceSelected,
  );

  const title = `Map Revv fields to ${dataSource.label} fields to fetch data`;

  return (
    <div className="templates-header-map-header">
      <div
        className="datastudio-back-ico"
        data-test="datastudio-back-button-ico"
        onClick={_selectAnotherDataSource}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        <FontAwesomeIcon icon={["far", "arrow-left"]} />
      </div>
      <div className="templateheader-container-map-header">
        <div className="datastudio-title-wrapper">
          <div className="templateheader-title">{title}</div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  FieldsSettingStore: { dataSourceSelected, syncDataSource: syncedData },
}) => ({
  dataSourceSelected,
  syncedData,
});

const mapDispatchToProps = {
  syncDataSource: startSyncingDataSource,
  updateDatasource: updateDataSourceSelected,
  updateStudioView: updateDataStdioView,
  resetCurrObject: resetCurrentSelectedObject,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapperHeader);
